export default __webpack_public_path__ + "static/banner-back-b4224d24c7b1117054b0fa7df7b60bfa.webp";